const middleware = {}

middleware['authenticated'] = require('../client/middleware/authenticated.js')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['route-redirect'] = require('../client/middleware/route-redirect.js')
middleware['route-redirect'] = middleware['route-redirect'].default || middleware['route-redirect']

middleware['router-config/routes-config'] = require('../client/middleware/router-config/routes-config.js')
middleware['router-config/routes-config'] = middleware['router-config/routes-config'].default || middleware['router-config/routes-config']

export default middleware
